import api from "../api";
import ApiConstant from "../../constants/api.constants";
import { AssignRoleDTO, CreateRolesDTO, UpdateRolesDTO, UpdateUserRoleDTO } from "../../models/user-role/role-model";

const RoleService = {
    //------------------------------------ Assign Role-------------------
    assignRoleToUser: async (data: AssignRoleDTO) => {
        try {
            const response = await api.post(ApiConstant.assignRoleToUser, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getAllRoles: async () => {
        try {
            const response = await api.get(ApiConstant.GetAllRolesAsync);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // FIXED: Send complete RoleSearchDTO in POST body
    getAllUserRoles: async (
        pageNumber: number = 1,
        pageSize: number = 10,
        sortBy: string = "modifiedDate",
        sortOrder: string = "desc",
        searchRoleId: number = 0,
        searchUserId: number = 0
    ) => {
        try {
            const body = {
                pageNumber,
                pageSize,
                searchRoleId,        // Backend expects int (0 = no filter)
                searchUserId,        // Backend expects long (0 = no filter)
                sortBy,              // Now properly sent in body
                sortOrder            // Now properly sent in body
            };
            console.log("Sending to API:", body);
            const response = await api.post(ApiConstant.getAllUserRoles, body);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateUserRole: async (data: UpdateUserRoleDTO) => {
        try {
            const response = await api.put(ApiConstant.updateUserRole, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    removeRoleFromUser: async (userId: number, roleId: number) => {
        try {
            const response = await api.delete(`${ApiConstant.removeRoleFromUser}?userId=${userId}&roleId=${roleId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    //------------------------------------ Role Creation-------------------
    getRoles: async (query?: string) => {
        try {
            let url = ApiConstant.Getallroles;
            if (query) {
                url += `?${query}`;
            }
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    createRole: async (data: CreateRolesDTO) => {
        try {
            const response = await api.post(ApiConstant.CreateRoles, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateRole: async (data: UpdateRolesDTO) => {
        try {
            const response = await api.put(ApiConstant.UpdateRoles, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    deleteRole: async (roleId: number) => {
        try {
            const response = await api.delete(`${ApiConstant.DeleteRoles}?RoleId=${roleId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    GetRolePermissionsAsync: async (roleId: number) => {
        try {
            const response = await api.get(`${ApiConstant.GetRolePermissionsAsync}/${roleId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    UpdateRolePermissionsAsync: async (data: any) => {
        try {
            console.log("Sending to API:", data);
            const response = await api.put(ApiConstant.UpdateRolePermissionsAsync, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default RoleService;
